import dynamic from "next/dynamic";

import type { Props as StarlingImagePopoverProps } from "./starling-image-popover";

export const DynamicStarlingImagePopover = dynamic<StarlingImagePopoverProps>(
  () => import("./starling-image-popover").then(module => module.StarlingImagePopover),
  { ssr: false },
);
